<template>
  <section>
        <b-form>
          <job-form :job=job :run_now=run_now :task_definitions=task_definitions></job-form>
        </b-form>
  </section>
</template>


<script>

import JobApi from '../../apis/JobsApi';
import JobForm from './JobForm.vue';

export default {
  components: {
    JobForm
  },
  props: {
    job: {
      type: String,
      required: true
    },
    run_now: {
      type: String,
      required: true
    },
    task_definitions: {
      type: Array,
      required: true

    }
  }
}
</script>
